const appConfig = fetch('/config/app-config.json', {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
    },
})
    .then((res) => res.json())
    .then((res) => ({
    prefixUrl: res.apiServerUri,
    redirectUri: encodeURIComponent(res.redirectUri),
    playServer: res.playServer,
}));
const restConfig = appConfig.then((appConfig) => ({
    prefixUrl: appConfig.prefixUrl,
    credentials: 'include',
}));
const configService = { appConfig, restConfig };
export { configService };
